import { Link, Navigate, useNavigate, useLocation } from "react-router-dom"

import { useEffect, useState } from "react"
import { useTranslation } from "react-i18next"
import { Button } from "react-bootstrap"
import {
  IconAlertCircle,
  IconArrowLeft,
} from "../../components/utils/Icons/CustomIcons"
import "react-toastify/dist/ReactToastify.css"
import { useForm } from "react-hook-form"
import { useAppDispatch, useAppSelector } from "../../redux/store"
import { loginPhoneStepOne, setError } from "../../redux/slices/auth/authSlice"
import { getPovSubscription } from "@/redux/slices/payments/paymentsSlices"
import { logoutUser } from "@/redux/slices/auth/authSlice"
import { setLanguage } from "@/redux/slices/auth/authSlice"
import { ToastContainer, toast } from "react-toastify"
import api from "@/api/api"
import { AsyncResource } from "async_hooks"
import Spinner from "react-bootstrap/Spinner"
import LoaderLight from "@/LoaderLight"

const listPurchase = [
  // {
  //   label: "SAR 64.99",
  //   numberOfGuests: 15,
  //   Id: "inviteSmart15Guests",
  // },
  {
    label: "SAR 64.99",
    numberOfGuests: 20,
    id: "inviteSmart15Guests",
  },
  {
    label: "SAR 149.99",
    numberOfGuests: 50,
    id: "inviteSmart50Guests",
  },
  {
    label: "SAR 249.99",
    numberOfGuests: 100,
    id: "inviteSmart100Guests",
  },
  {
    label: "SAR 429.99",
    numberOfGuests: 200,
    id: "inviteSmart200Guests",
  },
]

interface IForm {
  phone: string
}
const findLatestEntitlement = (entitlements: any) => {
  const entitlementList = Object.values(entitlements)
  return entitlementList.reduce((latest: any, current: any) => {
    return new Date(current.purchase_date) > new Date(latest.purchase_date)
      ? current
      : latest
  })
}
const Purchase = () => {
  const { lang, error, status, email, phone, first_name, last_name } =
    useAppSelector((state) => state.auth)
  const { currentPovPlan } = useAppSelector((state) => state?.payments)
  const [loading, setLoading] = useState(false)
  const navigate = useNavigate()
  const { t, i18n } = useTranslation()
  const location = useLocation()
  const dispatch = useAppDispatch()
  const [langs, setLang] = useState(t("header.language2"))
  const [plans, setPlans] = useState<any>(null)
  const [loadingPlans, setLoadingPlans] = useState(false)
  const changeLanguage = (language: string) => {
    let html = document.querySelector("html") || null
    i18n.changeLanguage(language)

    switch (language) {
      case "ar":
        html?.setAttribute("dir", "rtl")
        break
      default:
        html?.setAttribute("dir", "ltl")
        break
    }
    dispatch(setLanguage(language))
    setLang(language)
  }

  useEffect(() => {
    if (email) {
      dispatch(getPovSubscription(email ? email : phone ? phone : ""))
    }
  }, [email, phone])

  useEffect(() => {
    const fetchPlan = async () => {
      try {
        setLoadingPlans(true)
        const identifier = email || phone || ""
        const res = await api.events.inviteSmartPackages()
        if (res.status == 200) {
          setPlans(res?.data?.data)
        }
        setLoadingPlans(false)
        console.log("res plan", res)
      } catch (error) {
        setLoadingPlans(false)

        console.error("Error fetching subscription:", error)
      }
    }

    fetchPlan()
  }, [])
  const handlePurchase = async (data: any, index: number) => {
    console.log("data", data)
    try {
      setLoading(true) // Set the loading index to the current button's index
      const priceId = `inviteSmart${data?.guest}Guests`
      const response = await api.payments.createStripeCheckoutSession({
        priceId: priceId,
        mode: "payment",
      })

      if (response?.status) {
        setLoading(false) // Set the loading index to the current button's index
        const url = response?.data?.checkout_url

        if (url) {
          window.location.href = url
        } else {
          toast.error("Something went wrong: Invalid URL")
        }
      } else {
        toast.error("Something went wrong: Response status not OK")
      }
    } catch (error: any) {
      setLoading(false) // Stop loading spinner

      // Check for various error types
      if (error.response) {
        // Server responded with a status code outside the 2xx rang
        toast.error(
          `Error: ${error.response.status} - ${
            error.response.data?.message || "Server error"
          }`,
        )
      } else if (error.request) {
        // Request was made but no response was received
        toast.error(
          "Network Error: No response from the server. Please try again.",
        )
      } else {
        // Something happened in setting up the request
        toast.error(`Error: ${error.message}`)
      }
    } finally {
      setLoading(false)
    }
  }
  return (
    <>
      {loading ? (
        <LoaderLight />
      ) : (
        <div
          className=" container profile-section"
          style={{ minHeight: "100vh" }}
        >
          <div className="container container-profile">
            <div
              className="mb-4 "
              style={{ width: "80px", marginLeft: "-20px" }}
            >
              <Button
                className="d-flex align-items-center "
                style={{
                  backgroundColor: "transparent",
                  border: "none",
                  color: "black",
                  fontSize: "18px",
                  textDecoration: "none",
                  textTransform: "none",
                }}
                onClick={() => navigate(-1)}
              >
                <IconArrowLeft />
                <span className="reminders-page__link-text">
                  {t("buttons.backNew")}
                </span>
              </Button>
            </div>{" "}
          </div>
          <h4 className="d-flex justify-content-start align-items-center mb-2  fw-bold">
            {t("purchase.title")}
          </h4>
          <div className="w-100 row gap-2 p-3">
            {loadingPlans ? (
              <div
                className="d-flex justify-content-center align-items-center"
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  // height: "50vh",
                }}
              >
                <Spinner animation="border" role="status">
                  <span className="visually-hidden">Loading...</span>
                </Spinner>
              </div>
            ) : (
              <>
                {" "}
                {plans &&
                  plans?.length > 0 &&
                  plans?.map((data: any, index: number) => (
                    <div
                      key={index}
                      className="d-flex col-12 pe-4 ps-4 pt-3 pb-3"
                      style={{ backgroundColor: "#ffffff" }}
                    >
                      <div className="col-8">
                        <div className="d-flex flex-column gap-1">
                          <h6 className="fw-semibold fs-5">
                            {data?.title} {data?.price}
                          </h6>
                          <span
                            className="ps-1 pe-1 pt-1 pb-1  rounded-md d-flex align-items-center justify-content-center"
                            style={{
                              backgroundColor: "#2451921A",
                              fontSize: "14px",
                              width: "100px",
                              borderRadius: "15px",
                            }}
                          >
                            {data?.guest} {t("purchase.guests")}
                          </span>
                        </div>
                      </div>
                      <div className="col-4 d-flex align-items-center justify-content-end">
                        <Button
                          style={{
                            backgroundColor: "#245192",
                            border: "none",
                            color: "#ffffff",
                          }}
                          onClick={() => handlePurchase(data, index)}
                        >
                          {t("purchase.buyNow")}
                        </Button>
                      </div>
                    </div>
                  ))}
              </>
            )}
          </div>
          {/* <ToastContainer
            style={{ width: "90%", maxWidth: "400px", fontSize: "18px" }}
          /> */}
        </div>
      )}
    </>
  )
}

export default Purchase
